export default function TextInput(props) {

  return (
    <input className="form__fields__input form__fields__text" name={props.name} type="text" id={props.label} placeholder={props.label} required={props.required} />
  );
}
